export default __webpack_public_path__ + "static/media/bearshaman_icon.db62eca9.png";